<template>
  <div>
    <v-dialog v-model="showModal" persistent max-width="50%">
      <v-card>
        <v-app-bar text color="secondary">
          <v-toolbar-title class="subheading">{{ $t("participants.merge_to_existing") }}</v-toolbar-title>

          <v-spacer></v-spacer>
          <span>
            <v-chip color="warning darken-2" dark label> {{ $t("global.match_grade") }}: {{ matchGrade }}% </v-chip>
          </span>
        </v-app-bar>

        <v-divider></v-divider>

        <v-card-text class="px-3">
          <v-simple-table dense class="merge-table mt-3">
            <thead>
              <tr>
                <th class="grey-td text-sm-left" width="25%">{{ $t("enrolments.merge_th_field") }}</th>
                <th class="grey-td text-sm-left" width="25%">
                  {{ $t("participants.merge_existing_participant") }}
                </th>

                <th class="grey-td text-sm-left" width="25%">{{ $t("participants.merge_new_participant") }}</th>
                <th class="green-td text-sm-left" width="25%">{{ $t("enrolments.merge_th_result") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td :class="d_first_names.length > 1 ? 'existin-td' : 'grey-td'">{{ this.$t("enrolments.p_first_name") }}</td>
                <td :class="d_first_names.length > 1 ? 'existin-td' : ''">{{ this.existing_participant.first_name }}</td>
                <td :class="d_first_names.length > 1 ? 'existin-td' : ''">{{ this.new_participant.first_name || null }}</td>
                <td :class="d_first_names.length > 1 ? 'existin-td' : 'green-td'">
                  <v-select class="caption merge-dropdown" :items="d_first_names" v-model="output.first_name" text small dense></v-select>
                </td>
              </tr>
              <tr>
                <td :class="d_last_names.length > 1 ? 'existin-td' : 'grey-td'">{{ this.$t("enrolments.p_last_name") }}</td>
                <td :class="d_last_names.length > 1 ? 'existin-td' : ''">{{ this.existing_participant.last_name }}</td>
                <td :class="d_last_names.length > 1 ? 'existin-td' : ''">{{ this.new_participant.last_name || null }}</td>
                <td :class="d_last_names.length > 1 ? 'existin-td' : 'green-td'">
                  <v-select class="caption merge-dropdown" :items="d_last_names" v-model="output.last_name" text small dense></v-select>
                </td>
              </tr>
              <tr>
                <td :class="d_mobiles.length > 1 ? 'existin-td' : 'grey-td'">{{ this.$t("enrolments.p_mobile") }}</td>
                <td :class="d_mobiles.length > 1 ? 'existin-td' : ''">{{ this.existing_participant.mobile }}</td>
                <td :class="d_mobiles.length > 1 ? 'existin-td' : ''">
                  {{ this.$formatPhoneNumber(this.new_participant.mobile, this.new_participant.mobile_code) || null }}
                </td>
                <td :class="d_mobiles.length > 1 ? 'existin-td' : 'green-td'">
                  <v-select class="caption merge-dropdown" :items="d_mobiles" v-model="output.mobile" text small dense></v-select>
                </td>
              </tr>
              <tr>
                <td :class="d_date_of_births.length > 1 ? 'existin-td' : 'grey-td'">{{ this.$t("enrolments.p_date_of_birth") }}</td>
                <td :class="d_date_of_births.length > 1 ? 'existin-td' : ''">{{ this.existing_participant.date_of_birth }}</td>
                <td :class="d_date_of_births.length > 1 ? 'existin-td' : ''">{{ this.new_participant.date_of_birth || null }}</td>
                <td :class="d_date_of_births.length > 1 ? 'existin-td' : 'green-td'">
                  <v-select
                    class="caption merge-dropdown"
                    :items="d_date_of_births"
                    v-model="output.date_of_birth"
                    text
                    small
                    dense
                  ></v-select>
                </td>
              </tr>
              <tr>
                <td :class="d_streets.length > 1 ? 'existin-td' : 'grey-td'">{{ this.$t("enrolments.p_address_street") }}</td>
                <td :class="d_streets.length > 1 ? 'existin-td' : ''">{{ this.existing_participant.street }}</td>
                <td :class="d_streets.length > 1 ? 'existin-td' : ''">{{ this.new_participant.street || null }}</td>
                <td :class="d_streets.length > 1 ? 'existin-td' : 'green-td'">
                  <v-select class="caption merge-dropdown" :items="d_streets" v-model="output.street" text small dense></v-select>
                </td>
              </tr>
              <tr>
                <td :class="d_cities.length > 1 ? 'existin-td' : 'grey-td'">{{ this.$t("enrolments.p_address_city") }}</td>
                <td :class="d_cities.length > 1 ? 'existin-td' : ''">{{ this.existing_participant.city }}</td>
                <td :class="d_cities.length > 1 ? 'existin-td' : ''">{{ this.new_participant.city || null }}</td>
                <td :class="d_cities.length > 1 ? 'existin-td' : 'green-td'">
                  <v-select class="caption merge-dropdown" :items="d_cities" v-model="output.city" text small dense></v-select>
                </td>
              </tr>
              <tr>
                <td :class="d_zips.length > 1 ? 'existin-td' : 'grey-td'">{{ this.$t("enrolments.p_address_zip") }}</td>
                <td :class="d_zips.length > 1 ? 'existin-td' : ''">{{ this.existing_participant.zip }}</td>
                <td :class="d_zips.length > 1 ? 'existin-td' : ''">{{ this.new_participant.zip || null }}</td>
                <td :class="d_zips.length > 1 ? 'existin-td' : 'green-td'">
                  <v-select class="caption merge-dropdown" :items="d_zips" v-model="output.zip" text small dense></v-select>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
        <v-card-actions class="pr-2 pt-2 pb-3">
          <v-spacer></v-spacer>
          <action-button type="merge" @click="merge()" v-if="$can('participant-access')" color="success" small />
          <action-button type="cancel" color="error" @click="cancel" small />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "ParticipantHandleDuplicatePopup",
  props: ["id", "new_participant", "show"],
  data() {
    return {
      showModal: false,
      existing_participant: {},
      output: {},

      matchGrade: 0,

      d_emails: [],
      d_first_names: [],
      d_last_names: [],
      d_mobiles: [],
      d_date_of_births: [],
      d_streets: [],
      d_cities: [],
      d_zips: [],
      d_images: [],
      d_countries: [],
      d_companies: []
    }
  },

  created() {},

  watch: {
    show: {
      handler() {
        if (this.show && this.id) {
          this.showModal = true
          this.premerge(this.id)
        }
      }
    }
  },

  methods: {
    premerge() {
      axios
        .get(this.API_URL + "participant/" + this.id)
        .then((res) => {
          this.existing_participant = JSON.parse(JSON.stringify(res.data.data))

          if (this.new_participant && this.existing_participant) {
            let new_p_mobile = this.$formatPhoneNumber(this.new_participant.mobile, this.new_participant.mobile_code)

            this.d_emails = _.union(_.compact([this.new_participant.email, this.existing_participant.email]))
            this.d_first_names = _.union(_.compact([this.new_participant.first_name, this.existing_participant.first_name]))
            this.d_last_names = _.union(_.compact([this.new_participant.last_name, this.existing_participant.last_name]))
            this.d_mobiles = _.union(_.compact([new_p_mobile, this.existing_participant.mobile]))
            this.d_date_of_births = _.union(_.compact([this.new_participant.date_of_birth, this.existing_participant.date_of_birth]))
            this.d_streets = _.union(_.compact([this.new_participant.street, this.existing_participant.street]))
            this.d_cities = _.union(_.compact([this.new_participant.city, this.existing_participant.city]))
            this.d_zips = _.union(_.compact([this.new_participant.zip, this.existing_participant.zip]))

            this.matchGrade = this.$getMatchGrade(
              _.compact([this.new_participant.email, this.existing_participant.email]),
              _.compact([this.new_participant.first_name, this.existing_participant.first_name]),
              _.compact([this.new_participant.last_name, this.existing_participant.last_name]),
              _.compact([new_p_mobile, this.existing_participant.mobile]),
              _.compact([this.new_participant.date_of_birth, this.existing_participant.date_of_birth])
            )

            this.output = {
              first_name: this.new_participant.first_name || this.existing_participant.first_name,
              last_name: this.new_participant.last_name || this.existing_participant.last_name,
              email: this.new_participant.email || this.existing_participant.email,
              mobile: new_p_mobile || this.existing_participant.mobile,
              date_of_birth: this.new_participant.date_of_birth || this.existing_participant.date_of_birth,
              street: this.new_participant.street || this.existing_participant.street,
              city: this.new_participant.city || this.existing_participant.city,
              zip: this.new_participant.zip || this.existing_participant.zip
            }

            let auto_merge = true
            if (this.d_first_names.length > 0 && this.d_first_names.length != 1) auto_merge = false
            if (this.d_last_names.length > 0 && this.d_last_names.length != 1) auto_merge = false
            if (this.d_mobiles.length > 0 && this.d_mobiles.length != 1) auto_merge = false
            if (this.d_date_of_births.length > 0 && this.d_date_of_births.length != 1) auto_merge = false
            if (this.d_streets.length > 0 && this.d_streets.length != 1) auto_merge = false
            if (this.d_cities.length > 0 && this.d_cities.length != 1) auto_merge = false
            if (this.d_zips.length > 0 && this.d_zips.length != 1) auto_merge = false

            if (auto_merge) {
              //this.merge()
            }
          }
        })
        .catch((err) => console.log(err))
    },

    merge() {
      this.cancel()
      this.$emit("callback_parhandledup_merge", {
        id: this.id,
        output: this.output
      })
    },

    cancel() {
      this.showModal = false
      this.existing_participant = {}
      this.$emit("callback_parhandledup_cancel")
    }
  }
}
</script>
<style>
.merge-table table td,
.merge-table table th {
  border-color: #ccc !important;
  height: 43px !important;
  color: #555 !important;
}

.merge-table table .grey-td {
  background-color: #eee !important;
}

.merge-table table .green-td {
  background-color: #c8e6c9 !important;
}

.merge-table table .existin-td {
  background-color: #fee8eb !important;
  color: #000 !important;
}

.merge-dropdown {
  height: 33px !important;
}

.merge-dropdown .v-input__slot::before {
  border: none !important;
}

.merge-dropdown .v-input__slot::after {
  border: none !important;
}

.merge-dropdown .v-select__selection {
  font-size: 12px !important;
}
</style>
